<template>
  <section
    id="aos-section2"
    class="relative inline-flex w-full flex-col items-center overflow-hidden bg-slate-100 lg:h-[950px]"
  >
    <div id="aos-section2-bg" class="absolute z-0 flex size-full items-center justify-center">
      <OptimizedImage
        base-path="image/home/img_guardiann_brain"
        file-name="img_guardiann_brain"
        alt="img_guardiann_brain"
        image-class="w-[300px] h-[210px] lg:size-auto"
      />
    </div>

    <div class="gn-container relative h-full py-[60px] sm:px-0 lg:py-[120px]">
      <div
        data-aos="fade"
        data-aos-anchor="#aos-section2"
        class="animation-2 flex flex-col items-center gap-2 lg:w-full lg:gap-2.5"
      >
        <span class="gn-text-xl font-bold text-slate-600">
          {{ $t('main.section2.subTitle2') }}
        </span>
        <h2 class="gn-text-3xl font-extrabold">
          <span class="text-blue-500">P</span>ersonality & <span class="text-blue-500">E</span>motional
          <span class="text-blue-500">R</span>esilience <span class="text-blue-500">Q</span>uotient
        </h2>
      </div>

      <div
        data-aos="fade"
        data-aos-anchor="#aos-section2"
        data-aos-delay="600"
        class="animation-3 grid flex-1 gap-x-5 gap-y-2 py-9 lg:w-full lg:grid-cols-5 lg:pt-[150px]"
      >
        <div
          v-for="(item, index) in cardText"
          :key="index"
          class="inline-flex w-[260px] items-center justify-center rounded-xl bg-white/70 px-3 py-1 backdrop-blur-[2px] lg:h-[200px] lg:w-auto lg:max-w-60 lg:flex-col lg:rounded-3xl lg:p-8"
        >
          <img :src="useDynamicImage(item.icon)" :alt="`icon_test_result_${item.name}`" class="size-8 lg:size-24" />
          <span class="gn-text-xl font-extrabold">
            {{ item.name }}
          </span>
        </div>
      </div>

      <div data-aos="fade" data-aos-anchor="#aos-section2" data-aos-delay="1200">
        <i18n-t
          keypath="main.section2.context"
          tag="p"
          :class="['animation-4 gn-text-xl font-bold lg:whitespace-pre-line lg:py-5']"
        >
          <template #context-suffix>
            <span class="font-extrabold"> {{ $t('main.section2.context-suffix') }}</span>
          </template>
        </i18n-t>
      </div>
    </div>
  </section>
</template>

<script setup>
import OptimizedImage from '~/components/common/OptimizedImage.vue'

const {t} = useI18n()
const cardText = [
  {
    icon: 'svg/icon_test_result_family.svg',
    name: t('pqtest.result.family.title')
  },
  {
    icon: 'svg/icon_test_result_tenacity.svg',
    name: t('pqtest.result.tenacity.title')
  },
  {
    icon: 'svg/icon_test_result_sociality.svg',
    name: t('pqtest.result.sociality.title')
  },
  {
    icon: 'svg/icon_test_result_innovation.svg',
    name: t('pqtest.result.innovation.title')
  },
  {
    icon: 'svg/icon_test_result_emotional.svg',
    name: t('pqtest.result.emotional.title')
  }
]
</script>

<style lang="scss" scoped>
[data-aos='fade-in-hidden'] {
  opacity: 0;
  transform: translateY(20px);
  transition-property: transform, opacity;
  transition-duration: 1s;

  &.aos-animate {
    opacity: 1;
    transform: translateY(0);
    animation: fadeInOut 1.5s ease-in-out forwards;
  }
}

// 요소가 사라질 때 공간 차지하지 않도록
[data-aos='fade-in-hidden'].aos-animate:not(:hover) {
  // 애니메이션 완료 후 요소 처리
  animation-fill-mode: forwards;
  position: absolute;
}

@keyframes fadeInOut {
  0% {
    opacity: 0;
    transform: translateY(20px);
    visibility: visible;
  }
  20% {
    // 0.24초에 완전히 보이는 상태
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }
  50% {
    // 0.6초까지 보이는 상태 유지
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
  }
  100% {
    // 1.2초에는 완전히 사라짐
    opacity: 0;
    transform: translateY(-20px);
    visibility: hidden;
  }
}
</style>
